export default "__VITE_ASSET__DStVxbny__"